"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useManagedWranglerSelectionsContext = exports.ManagedWranglerSelectionsProvider = exports.ManagedWranglerSelectionsContext = void 0;
var react_1 = __importStar(require("react"));
var WranglerDataProvider_1 = __importDefault(require("./WranglerDataProvider"));
exports.ManagedWranglerSelectionsContext = react_1.createContext(undefined);
function ManagedWranglerSelectionsProvider(props) {
    // These "setXyzState" functions are lower level functions that just set the state. 
    // The higher-level functions (setXyz) will update the local state, as well as the state defined
    // in the tracking provider.
    var _a = react_1.useState(props.selectedQuantity), selectedQuantity = _a[0], setSelectedQuantityState = _a[1];
    var _b = react_1.useState(props.selectedAttributes || {}), selections = _b[0], setSelectionsState = _b[1];
    function setSelectedQuantity(quantity) {
        setSelectedQuantityState(quantity);
        if (props.onChangeQuantity) {
            props.onChangeQuantity(quantity, selectedQuantity);
        }
    }
    function setSelections(newSelections) {
        setSelectionsState(newSelections);
        if (props.onChangeSelections) {
            props.onChangeSelections(newSelections, selections);
        }
    }
    return react_1.default.createElement(exports.ManagedWranglerSelectionsContext.Provider, { value: {
            setSelectedQuantity: setSelectedQuantity,
            setSelections: setSelections
        } },
        react_1.default.createElement(WranglerDataProvider_1.default, __assign({}, props, { selectedAttributes: selections, selectedQuantity: selectedQuantity }), props.children));
}
exports.ManagedWranglerSelectionsProvider = ManagedWranglerSelectionsProvider;
;
/**
 * Accesses the wrangler managed data context.  This contains the users selections of quantity & attributes.
 */
var useManagedWranglerSelectionsContext = function () {
    return react_1.useContext(exports.ManagedWranglerSelectionsContext);
};
exports.useManagedWranglerSelectionsContext = useManagedWranglerSelectionsContext;
//# sourceMappingURL=ManagedWranglerSelectionsProvider.js.map